import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AddressBookService = /** @class */ (function () {
    function AddressBookService(http) {
        this.http = http;
    }
    AddressBookService.prototype.getContacts = function (payload) {
        return this.http.post('/address-book', payload);
    };
    AddressBookService.ngInjectableDef = i0.defineInjectable({ factory: function AddressBookService_Factory() { return new AddressBookService(i0.inject(i1.HttpClient)); }, token: AddressBookService, providedIn: "root" });
    return AddressBookService;
}());
export { AddressBookService };
